import React from "react";
import { connect } from "react-redux";
import moment from "moment";

function HourLine({ language, day, period }) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "110px auto 150px",
        marginBottom: 10,
      }}
    >
      <p style={{ textAlign: language === "arabic" ? "right" : "left" }}>
        {day}
      </p>
      <span></span>
      <div>
        <p style={{ textAlign: language === "arabic" ? "left" : "right" }}>
          {period}
        </p>
      </div>
    </div>
  );
}
function Hours({ language, branch }) {
  const mergeSlots = () => {
    const slots = branch.slots;
    let temp = [];
    let ignoreSlots = [];
    slots.forEach((slot) => {
      if (
        !ignoreSlots.find(
          (s) =>
            s.day === slot.day && s.start === slot.start && s.end === slot.end
        )
      ) {
        const possibleMergeAfter = slots.find(
          (t) => t.day === (slot.day + 1) % 7
        );

        if (
          possibleMergeAfter &&
          possibleMergeAfter.start.startsWith("00:00") &&
          possibleMergeAfter.end <= "04:00:00" &&
          slot.end.startsWith("23:59")
        ) {
          temp.push({
            day: slot.day,
            start: slot.start,
            end: possibleMergeAfter.end,
          });
          ignoreSlots.push(possibleMergeAfter);
          let removeIndex = temp.findIndex(
            (t) =>
              t.day === possibleMergeAfter.day &&
              t.start === possibleMergeAfter.start &&
              t.end === possibleMergeAfter.end
          );
          if (removeIndex >= 0) {
            temp.splice(removeIndex, 1);
          }
        } else temp.push(slot);
      }
    });
    return temp;
  };

  const slots = mergeSlots(branch.slots);
  if (!slots?.length) return <></>;

  const tDay = (day) => {
    if (language === "english") return day;
    const translations = {
      Sunday: "الأحد",
      Monday: "الاثنين",
      Tuesday: "الثلاثاء",
      Wednesday: "الأربعاء",
      Thursday: "الخميس",
      Friday: "الجمعة",
      Saturday: "السبت",
    };
    return translations[day];
  };

  const tPMAM = (period) => {
    if (language === "english") return period;
    return period.replace(/AM/g, "ص").replace(/PM/g, "م");
  };
  return (
    <div style={{ marginTop: 35 }}>
      <p
        className="box-title"
        style={{ textAlign: language === "arabic" ? "right" : "left" }}
      >
        {language == "arabic" ? "ساعات العمل" : "Hours"}
      </p>
      <div
        style={{
          minHeight: 70,
          direction: language == "english" ? "ltr" : "rtl",
          backgroundColor: "white",
          textAlign: language === "arabic" ? "right" : "left",
          padding: "25px 20px 1px",
        }}
        className="w-100 bordered"
      >
        {slots.map((slot) => (
          <HourLine
            language={language}
            day={tDay(
              moment()
                .isoWeekday(slot.day + 1)
                .format("dddd")
            )}
            period={tPMAM(
              `${moment(slot.start, "HH:mm:ss").format("h:mm A")} - ${moment(
                slot.end,
                "HH:mm:ss"
              ).format("h:mm A")}`
            )}
          />
        ))}
      </div>
      <div style={{ height: 100 }}></div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
  };
};
export default connect(mapStateToProps)(Hours);
